export default function truncateText(text: string, maxLength: number): string{
    if (!text) return '';
    if (text.length <= maxLength) return text;
    
    // Reserve 3 characters for the ellipsis
    return text.slice(0, maxLength - 3) + '...';
  };